var TOTAL_HEIGHT = 1.75;
var TOTAL_WEIGHT = 65;
var THORAX_HEIGHT_PCT = 12.7;
var THORAX_WEIGHT_PCT = 18.56;
var ABDOMEN_HEIGHT_PCT = 8.1;
var ABDOMEN_WEIGHT_PCT = 12.65;
var HIP_WEIGHT_PCT = 14.85;
var BIACROMIAL_DIST_PCT = 22.25;
var HEAD_WEIGHT_PCT = 8.23;
var TORSO_CM_Z_PCT = 59.95;
var TORSO_WEIGHT_PCT = THORAX_WEIGHT_PCT + ABDOMEN_WEIGHT_PCT + HEAD_WEIGHT_PCT;
var PELVIS_HEIGHT_PCT = 9.3;
var BIILIAC_HEIGHT_PCT = 11.65;
var UPPER_ARM_HEIGHT_PCT = 17.25;
var UPPER_ARM_CM_Z_PCT = 43.2;
var UPPER_ARM_WEIGHT_PCT = 3.82;
var LOWER_ARM_HEIGHT_PCT = 15.85;
var LOWER_ARM_CM_Z_PCT = 44.7;
var LOWER_ARM_WEIGHT_PCT = 1.87;
var UPPER_LEG_HEIGHT_PCT = 24.05;
var UPPER_LEG_CM_Z_PCT = 43.05;
var UPPER_LEG_WEIGHT_PCT = 11.112;
var LOWER_LEG_HEIGHT_PCT = 25.2;
var LOWER_LEG_CM_Z_PCT = 42.6;
var LOWER_LEG_WEIGHT_PCT = 5.05;
function PART_MASS(pct) {
    return TOTAL_WEIGHT * pct / 100;
}
function PART_LEN(pct) {
    return TOTAL_HEIGHT * pct / 100;
}
function PART_CM_LEN(partLen, pct) {
    return partLen * pct / 100;
}
var DIMS = {
    TOTAL_HEIGHT: TOTAL_HEIGHT,
    TORSO_HEIGHT: PART_LEN(THORAX_HEIGHT_PCT + ABDOMEN_HEIGHT_PCT),
    TOTAL_MASS: TOTAL_WEIGHT,
    TORSO_WIDTH: PART_LEN(BIACROMIAL_DIST_PCT),
    TORSO_DEPTH: 0.10,
    TORSO_CM_Z: PART_CM_LEN(PART_LEN(THORAX_HEIGHT_PCT + ABDOMEN_HEIGHT_PCT), TORSO_CM_Z_PCT),
    TORSO_MASS: PART_MASS(TORSO_WEIGHT_PCT),
    UPPER_ARM_HEIGHT: PART_LEN(UPPER_ARM_HEIGHT_PCT),
    UPPER_ARM_WIDTH: 0.085,
    UPPER_ARM_DEPTH: 0.085,
    UPPER_ARM_MASS: PART_MASS(UPPER_ARM_WEIGHT_PCT),
    UPPER_ARM_CM_Z: PART_CM_LEN(PART_LEN(UPPER_ARM_HEIGHT_PCT), UPPER_ARM_CM_Z_PCT),
    LOWER_ARM_HEIGHT: PART_LEN(LOWER_ARM_HEIGHT_PCT),
    LOWER_ARM_WIDTH: 0.07,
    LOWER_ARM_DEPTH: 0.07,
    LOWER_ARM_CM_Z: PART_CM_LEN(PART_LEN(LOWER_ARM_HEIGHT_PCT), LOWER_ARM_CM_Z_PCT),
    LOWER_ARM_MASS: PART_MASS(LOWER_ARM_WEIGHT_PCT),
    HIP_HEIGHT: PART_LEN(PELVIS_HEIGHT_PCT),
    HIP_WIDTH: PART_LEN(BIILIAC_HEIGHT_PCT),
    HIP_DEPTH: 0.10,
    HIP_MASS: PART_MASS(HIP_WEIGHT_PCT),
    UPPER_LEG_HEIGHT: PART_LEN(UPPER_LEG_HEIGHT_PCT),
    UPPER_LEG_WIDTH: 0.095,
    UPPER_LEG_DEPTH: 0.095,
    UPPER_LEG_MASS: PART_MASS(UPPER_LEG_WEIGHT_PCT),
    UPPER_LEG_CM_Z: PART_CM_LEN(PART_LEN(UPPER_LEG_HEIGHT_PCT), UPPER_LEG_CM_Z_PCT),
    LOWER_LEG_HEIGHT: PART_LEN(LOWER_LEG_HEIGHT_PCT),
    LOWER_LEG_WIDTH: 0.09,
    LOWER_LEG_DEPTH: 0.09,
    LOWER_LEG_MASS: PART_MASS(LOWER_LEG_WEIGHT_PCT),
    LOWER_LEG_CM_Z: PART_CM_LEN(PART_LEN(LOWER_LEG_HEIGHT_PCT), LOWER_LEG_CM_Z_PCT),
};
export default DIMS;
//# sourceMappingURL=dimensions.js.map